// components/EmployeeTable.js
import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
  Box,
  Avatar
} from '@mui/material';

const EmployeeTable = ({ data, onSalary, onEdit, onDelete, page, rowsPerPage, onPageChange, onMonthly, totalEntries, onRowsPerPageChange, onViewTotalAvgHours }) => (
  <>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell><b>Employee Id</b></TableCell>
          <TableCell><b>Name</b></TableCell>
          <TableCell><b>Position</b></TableCell>
          <TableCell><b>Email</b></TableCell>
          <TableCell><b>Joining Date</b></TableCell>
          <TableCell><b>Total Hours & Daily Avg Hours</b></TableCell>
          <TableCell><b>Monthly Hours</b></TableCell>
          <TableCell><b>Salary($)</b></TableCell>
          <TableCell align="center"><b>Actions</b></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((user, index) => (
          <TableRow key={index}>
            <TableCell>{user.id}</TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar src={user.avatar} sx={{ marginRight: 1 }} />
                {user.name}
              </Box>
            </TableCell>
            <TableCell>{user.position}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.joiningDate}</TableCell>
            <TableCell>
            <Button
                variant="outlined"
                color="primary"
                sx={{ marginRight: 1, mb: 1 }}
                onClick={() => onViewTotalAvgHours(user)}  // Trigger Total & Avg Hours Dialog
              >
                View
              </Button>
            </TableCell>
            <TableCell>
              <Button
                variant="outlined"
                color="primary"
                sx={{ marginRight: 1, mb: 1 }}
                onClick={() => onMonthly(user)}  // Trigger Monthly Hours Dialog
              >
                View
              </Button>
            </TableCell>
            <TableCell>
              <Button
                variant="outlined"
                color="primary"
                sx={{ marginRight: 1, mb: 1 }}
                onClick={() => onSalary(user)}
              >
                Salary
              </Button>
            </TableCell>
            <TableCell align="center">
              <Button
                variant="contained"
                color="primary"
                sx={{ marginRight: 1, mb: 1 }}
                onClick={() => onEdit(user)}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => onDelete(user)}
              >
                Delete
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>

    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={totalEntries}  // Total number of items in the filteredData
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  </>
);

export default EmployeeTable;
